import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import Button from "components/buttons";
import styles from "./styles/form-submit.css.js";

const FormSubmit = ({ classes, children, fullWidth = false, disabled }) => (
  <Button
    type="submit"
    fullWidth={fullWidth}
    variant="contained"
    color="primary"
    className={classes.submit}
    disabled={disabled}
  >
    {children}
  </Button>
);

FormSubmit.propTypes = {
  /**
   * Indica si se muestra en ancho completo
   */
  fullWidth: PropTypes.bool,
};

export default withStyles(styles)(FormSubmit);
